export const SET_STRUCT = 'SET_STRUCT';
export const SET_SPORTS = 'SET_SPORTS';
export const SET_SPORTS_WITH_EVENTS = 'SET_SPORTS_WITH_EVENTS';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_TOURNAMENTS = 'SET_TOURNAMENTS';
export const SET_MARKETS = 'SET_MARKETS';
export const SET_ODD_TYPES = 'SET_ODD_TYPES';
export const SET_MARKET_GROUP_INFOS = 'SET_MARKET_GROUP_INFOS';
export const SET_TOP_TEN_EVENTS = 'SET_TOP_TEN_EVENTS';
export const SET_TOP_EVENT_IDS = 'SET_TOP_EVENT_IDS';
export const SET_EVENTS = 'SET_EVENTS';
export const SET_EVENT = 'SET_EVENT';
// when event is finished
export const REMOVE_EVENTS = 'REMOVE_EVENTS';
export const REMOVE_EVENT = 'REMOVE_EVENT';
export const SET_TOP_TEN_EVENT = 'SET_TOP_TEN_EVENT';
export const SET_PROMOTIONAL_EVENTS = 'SET_PROMOTIONAL_EVENTS';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const SET_IS_OFFER_STARTING = 'SET_IS_OFFER_STARTING';
export const SET_IS_OFFER_READY = 'SET_IS_OFFER_READY';

export const SET_LIVE_EVENTS_COUNT = 'SET_LIVE_EVENTS_COUNT';
export const INCREMENT_ALL_CHANGES_ID = 'INCREMENT_ALL_CHANGES_ID';
export const SET_ARE_SUBSCRIPTIONS_SET = 'SET_ARE_SUBSCRIPTIONS_SET';
export const SET_IS_EVENTS_SUBSCRIPTION_SET = 'SET_IS_EVENTS_SUBSCRIPTION_SET';

export const SET_IS_OFFER_FETCHED = 'SET_IS_OFFER_FETCHED';
export const SET_IS_OFFER_FETCHED_BY_SPORT_ID = 'SET_IS_OFFER_FETCHED_BY_SPORT_ID';
export const SET_ARE_LIVE_EVENTS_FETCHED = 'ARE_LIVE_EVENTS_FETCHED';
export const SET_IS_SUPER_OFFER_FETCHED = 'SET_IS_SUPER_OFFER_FETCHED';
export const SET_ARE_TOP_TEN_EVENTS_FETCHED = 'SET_ARE_TOP_TEN_EVENTS_FETCHED';
export const SET_ARE_TOP_EVENT_IDS_FETCHED = 'SET_ARE_TOP_EVENT_IDS_FETCHED';
export const SET_ODD_VALUE_DYNAMICS = 'SET_ODD_VALUE_DYNAMICS';

export const SET_IS_COMPETITION_TREE_FETCHED_FOR_SPORT_ID = 'SET_IS_COMPETITION_TREE_FETCHED_FOR_SPORT_ID';
export const SET_COMPETITION_TREE_FOR_SPORT_ID = 'SET_COMPETITION_TREE_FOR_SPORT_ID';

export const SET_IS_FIRST_DAILY_OFFER_SYNC = 'SET_IS_FIRST_DAILY_OFFER_SYNC';
export const SET_IS_FIRST_STRUCT_SYNC = 'SET_IS_FIRST_STRUCT_SYNC';

export const SET_SPORT_DATES_WITH_ACTIVE_OFFER = 'SET_SPORT_DATES_WITH_ACTIVE_OFFER';

export const SET_POPULAR_SUPERBETS = 'SET_POPULAR_SUPERBETS';
export const SET_POPULAR_SUPERBETS_V2 = 'SET_POPULAR_SUPERBETS_V2';
